module.exports = __webpack_public_path__ + "img/5.d4fb5147.png";